import React from 'react'
import cn from 'classnames'

export interface FeatureProps {
  html: string
  image: {
    url: string
    alt: string
  }
  imageOnRight?: boolean
  lang?: string
  caption?: string
  onRenderImage?: (image: { url: string; alt: string }) => JSX.Element
  onRenderText?: () => JSX.Element
}

const Feature = ({ html, image, imageOnRight, caption, onRenderImage, onRenderText }: FeatureProps) => {
  if (!image.url) return null
  return (
    <section className='page-slice-spacer feature'>
      <div className='container px-0'>
        <div className={cn('d-md-flex', imageOnRight ? 'flex-row-reverse' : 'flex-row')}>
          <div
            className={cn('col col-md-6 feature__image', {
              'offset-md-1': imageOnRight,
              'offset-md-0': !imageOnRight
            })}
          >
            {/* allows custom rendering of image */}
            {onRenderImage ? (
              onRenderImage(image)
            ) : (
              <img className='image-rounded w-100 h-100' src={image.url} alt={image.alt || ''} />
            )}
            {caption && <p className='parag--sm font-italic pt-1'>{caption}</p>}
          </div>
          <div
            className={cn('pt-2 pt-md-0 col col-md-5', {
              'offset-md-0': imageOnRight,
              'offset-md-1': !imageOnRight
            })}
          >
            {/* allows custom rendering of rich text content */}
            {onRenderText ? (
              onRenderText()
            ) : (
              <div dangerouslySetInnerHTML={{ __html: html }} className='article' />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Feature
